import React from "react";
import { View, StyleSheet } from "react-native";

interface SeparatorProps {
  color: string;
  marginHorizontal?: number;
  height?: any;
  marginTop?: number;
  marginBottom?: number;
  width?: string;
}

const Separator: React.FC<SeparatorProps> = ({
  color,
  marginHorizontal = 10,
  height = 1,
  marginTop = 24,
  marginBottom = 24,
  width = "100%",
}) => (
  <View
    style={[
      styles.separator,
      {
        marginHorizontal: marginHorizontal,
        height: height,
        backgroundColor: color,
        marginTop: marginTop,
        marginBottom: marginBottom,
        // width:{`${width}`}
        width: width === "100%" ? width : parseFloat(width),
        zIndex: -1,
      },
    ]}
  />
);

const styles = StyleSheet.create({
  separator: {
    width: "100%",
  },
});

export default Separator;
